import createEnvironments from './endpoints';

export const environment = {
  ...createEnvironments('', 'https://iotgatet01.seepex.com'),
  production: false,
  envname: 'development',
};
